import {
    ILayoutState,
    ILayoutActionTypes,
    ISetLayoutAction,
    ISetHeightAction,
    UpdateLayoutSuccessActionType,
    UpdateLayoutFailureActionType,
    AddFieldToLayoutActionType,
    ReplaceFieldInLayoutActionType,
    DuplicateFieldToLayoutActionType,
    ILayoutList,
    UpdateLayoutRequestActionType,
    DeleteFieldFromLayoutActionType,
} from "./types";
import { Handler } from "./../types/store-types";
import _ from "lodash";
import { getNewFieldInitialLayout, getNewLayoutWithAddedItem } from "./../../helpers/layoutActions";

const initLayout: Handler<ILayoutState, ISetLayoutAction> = (state, { payload }) => {
    return { ...state, list: { ...payload } };
};

const setHeight: Handler<ILayoutState, ISetHeightAction> = (state, { payload }) => {
    const { list, edited } = state;
    const { id, height } = payload;
    const _list = _.cloneDeep(list);

    _list[id].h = height;
    _list[id].minH = height;
    _list[id].maxH = height;

    return { edited: edited + 1, list: _list };
};

const refreshLayout: Handler<ILayoutState, ISetLayoutAction> = state => {
    const { edited } = state;
    return { ...state, edited: edited + 1 };
};

const addFieldToLayoutData: Handler<ILayoutState, AddFieldToLayoutActionType> = (
    state,
    { payload: { fieldId, fieldType, layout } },
) => {
    const { list, edited } = state;
    const _list = _.cloneDeep(list);
    return { edited: edited + 1, list: getNewFieldInitialLayout(_list, fieldType, fieldId, layout) };
};

const replaceFieldInLayout: Handler<ILayoutState, ReplaceFieldInLayoutActionType> = (
    state,
    { payload: { tempId, fieldId } },
) => {
    const { list, edited } = state;
    const _list: ILayoutList = _.cloneDeep(list);
    _list[fieldId] = _list[tempId];
    delete _list[tempId];

    return { edited: edited + 1, list: _list };
};

const deleteFieldFromLayout: Handler<ILayoutState, DeleteFieldFromLayoutActionType> = (
    state,
    { payload: { deleteFieldId } },
) => {
    delete state.list[deleteFieldId];

    return { ...state };
};
/* -- Duplicate Layout Handlers -- */

const duplicateFieldToLayout: Handler<ILayoutState, DuplicateFieldToLayoutActionType> = (
    state,
    { payload: { pageFieldsIds, fieldId, tempId } },
) => {
    return {
        edited: state.edited + 1,
        list: getNewLayoutWithAddedItem(state.list, state.list[fieldId], { fieldId, tempId, pageFieldsIds }),
    };
};

/* -- Update Layout Request Handlers -- */

const updateLayoutRequest: Handler<ILayoutState, UpdateLayoutRequestActionType> = (state, { payload: { layout } }) => {
    const { list, edited } = state;
    return { ...state, list: { ...list, ...layout }, edited: edited + 1 };
};

const updateLayoutSuccess: Handler<ILayoutState, UpdateLayoutSuccessActionType> = state => {
    return { ...state };
};

const updateLayoutFailure: Handler<ILayoutState, UpdateLayoutFailureActionType> = state => {
    return { ...state };
};

export const layoutHandlers = {
    [ILayoutActionTypes.INIT_LAYOUT]: initLayout,
    [ILayoutActionTypes.SET_HEIGHT]: setHeight,
    [ILayoutActionTypes.REFRESH_LAYOUT]: refreshLayout,
    [ILayoutActionTypes.ADD_FIELD_TO_LAYOUT]: addFieldToLayoutData,
    [ILayoutActionTypes.REPLACE_FIELD_IN_LAYOUT]: replaceFieldInLayout,
    [ILayoutActionTypes.DELETE_FIELD_FROM_LAYOUT]: deleteFieldFromLayout,

    [ILayoutActionTypes.DUPLICATE_FIELD_TO_LAYOUT]: duplicateFieldToLayout,

    [ILayoutActionTypes.UPDATE_LAYOUT_REQUEST]: updateLayoutRequest,
    [ILayoutActionTypes.UPDATE_LAYOUT_SUCCESS]: updateLayoutSuccess,
    [ILayoutActionTypes.UPDATE_LAYOUT_FAILURE]: updateLayoutFailure,
};
